import axios from 'axios';
import { clearAlerts, setAlert } from './alert';
import {
    GET_SPAREPART_EXPENSES,
    GET_SPAREPART_EXPENSE,
    ADD_SPAREPART_EXPENSE,
    UPDATE_SPAREPART_EXPENSE,
    DELETE_SPAREPART_EXPENSE,
    SET_DELETE_SPAREPART_EXPENSE_ID,
    SET_UPDATE_SPAREPART_EXPENSE_ID,
    REMOVE_DELETE_SPAREPART_EXPENSE,
    REMOVE_UPDATE_SPAREPART_EXPENSE,
    SPAREPART_EXPENSE_ERROR,
    GET_EXPENSE_STATS,
    GET_EXPENSE_DATA,
    SET_LOADING,
    CLEAR_ERRORS
} from './types';

// Get all expenses with filters
export const getSparepartExpenses = (page = 1, filters = {}) => async (dispatch) => {
    try {
        dispatch({ type: SET_LOADING });
        
        let queryParams = '';
        if (filters) {
            Object.keys(filters).map((key, index) => queryParams += `&${key}=${filters[key]}`);
        }
        
        const res = await axios.get(`/sparepart-expenses?page=${page}${queryParams}`);
        
        dispatch({
            type: GET_SPAREPART_EXPENSES,
            payload: res.data,
        });
    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message || 'Sarflarni yuklashda xatolik', 'danger'));
        dispatch({
            type: SPAREPART_EXPENSE_ERROR,
            payload: err.response?.data || { message: 'Sarflarni yuklashda xatolik' }
        });
    }
};

// Get single expense
export const getSparepartExpense = (expenseId) => async (dispatch) => {
    try {
        const res = await axios.get(`/sparepart-expenses/${expenseId}`);
        
        dispatch({
            type: GET_SPAREPART_EXPENSE,
            payload: res.data,
        });
    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message || 'Sarfni yuklashda xatolik', 'danger'));
    }
};

// Create new expense
export const addSparepartExpense = (formData) => async (dispatch) => {
    dispatch({ type: SET_LOADING });
    dispatch(clearAlerts());

    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    try {
        const res = await axios.post('/sparepart-expenses', formData, config);

        dispatch({
            type: ADD_SPAREPART_EXPENSE,
            payload: res.data,
        });

        dispatch(getSparepartExpenses());
        dispatch(setAlert('Sarf muvaffaqiyatli yaratildi!', 'success'));
        
        return true;
    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message || 'Sarfni yaratishda xatolik', 'danger'));
        
        if (err?.response?.data?.errors) {
            dispatch({
                type: SPAREPART_EXPENSE_ERROR,
                payload: err.response.data,
            });
        }
        
        return false;
    }
};

// Update expense
export const updateSparepartExpense = (expenseId, formData, currentPage) => async (dispatch) => {
    dispatch(clearAlerts());

    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    try {
        const res = await axios.put(`/sparepart-expenses/${expenseId}`, formData, config);

        dispatch({
            type: UPDATE_SPAREPART_EXPENSE,
            payload: res.data,
        });

        dispatch({
            type: REMOVE_UPDATE_SPAREPART_EXPENSE
        });

        dispatch(getSparepartExpenses(currentPage));
        dispatch(setAlert('Sarf muvaffaqiyatli yangilandi!', 'success'));
        dispatch(clearExpenseErrors());
        
        return true;
    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message || 'Sarfni yangilashda xatolik', 'danger'));
        
        if (err?.response?.data?.errors) {
            dispatch({
                type: SPAREPART_EXPENSE_ERROR,
                payload: err.response.data,
            });
        }
        
        return false;
    }
};

// Delete expense
export const deleteSparepartExpense = (expenseId, currentPage) => async (dispatch) => {
    dispatch(clearAlerts());

    const config = {
        headers: {
            'Content-Type': 'application/json',
        },
    };

    try {
        await axios.delete(`/sparepart-expenses/${expenseId}`, config);

        dispatch({
            type: DELETE_SPAREPART_EXPENSE,
            payload: expenseId
        });

        dispatch({
            type: REMOVE_DELETE_SPAREPART_EXPENSE
        });

        dispatch(getSparepartExpenses(currentPage));
        dispatch(setAlert('Sarf muvaffaqiyatli o\'chirildi!', 'success'));
        dispatch(clearExpenseErrors());
        
        return true;
    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message || 'Sarfni o\'chirishda xatolik', 'danger'));
        
        return false;
    }
};



// Get expense statistics
export const getExpenseStats = (filters = {}) => async (dispatch) => {
    try {
        let queryParams = '';
        if (filters) {
            Object.keys(filters).map((key, index) => queryParams += `&${key}=${filters[key]}`);
        }
        
        const res = await axios.get(`/sparepart-expenses/stats?${queryParams}`);
        
        dispatch({
            type: GET_EXPENSE_STATS,
            payload: res.data,
        });
    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message || 'Statistikani yuklashda xatolik', 'danger'));
    }
};

// Get expense filter data (spare parts, warehouses, users, transports, machines)
export const getExpenseData = () => async (dispatch) => {
    try {
        // Load data for filters from multiple endpoints
        const [sparePartsRes, warehousesRes, usersRes, transportsRes, machinesRes] = await Promise.all([
            axios.get('/spare-parts?is_all=true'),
            axios.get('/warehouses?type=part'),
            axios.get('/users?is_all=true'),
            axios.get('/transports?is_all=true'),
            axios.get('/machines/options')
        ]);
        
        dispatch({
            type: GET_EXPENSE_DATA,
            payload: {
                spare_parts: sparePartsRes.data.data || sparePartsRes.data,
                warehouses: warehousesRes.data.data || warehousesRes.data,
                users: usersRes.data.data || usersRes.data,
                transports: transportsRes.data.data || transportsRes.data,
                machines: machinesRes.data.machines || machinesRes.data.data || machinesRes.data
            }
        });
    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message || 'Filter ma\'lumotlarini yuklashda xatolik', 'danger'));
        // Provide empty data as fallback
        dispatch({
            type: GET_EXPENSE_DATA,
            payload: {
                spare_parts: [],
                warehouses: [],
                users: [],
                transports: [],
                machines: []
            }
        });
    }
};

// Export expenses to XLSX
export const exportSparepartExpenses = (filters = {}) => async (dispatch) => {
    try {
        dispatch(setAlert('Hisobot tayyorlanmoqda...', 'info'));
        
        let queryParams = new URLSearchParams({
            ...filters,
            file_format: 'xlsx'
        }).toString();
        
        const response = await axios.get(`/sparepart-expenses/export?${queryParams}`);
        
        // Open file URL in new tab to trigger download
        if (response.data.file_url) {
            window.open(response.data.file_url, '_blank');
            dispatch(setAlert('Hisobot muvaffaqiyatli yuklandi!', 'success'));
        }
    } catch (err) {
        dispatch(setAlert(err?.response?.data?.message || 'Yuklab olishda xatolik', 'danger'));
    }
};

// Set expense for deletion
export const setDeleteSparepartExpenseId = (expenseId) => async (dispatch) => {
    dispatch({
        type: SET_DELETE_SPAREPART_EXPENSE_ID,
        payload: { expense_id: expenseId }
    });
};

// Set expense for update
export const setUpdateSparepartExpenseId = (expenseId) => async (dispatch) => {
    dispatch({
        type: SET_UPDATE_SPAREPART_EXPENSE_ID,
        payload: { expense_id: expenseId }
    });
};

// Remove delete expense
export const removeDeleteSparepartExpense = () => async (dispatch) => {
    dispatch({
        type: REMOVE_DELETE_SPAREPART_EXPENSE
    });
};

// Remove update expense
export const removeUpdateSparepartExpense = () => async (dispatch) => {
    dispatch({
        type: REMOVE_UPDATE_SPAREPART_EXPENSE
    });
};

// Clear errors
export const clearExpenseErrors = () => async (dispatch) => {
    dispatch({
        type: CLEAR_ERRORS
    });
}; 